import { Route, Navigate } from 'react-router-dom'

const PrivateRoute = ({ component: Component, isAuth = false, path, ...props }) => {
  // * Checks if user is authenticated if not sends the user to login
  if (!isAuth) {
    return <Navigate to='/login' />
  } else {
    return <Route path={path} element={<Component />} />
  }
}

export default PrivateRoute
